<script setup>
    import Image from '@/components/Image.vue';

    defineProps(['step']);
    const emit = defineEmits(['select-option']);
</script>

<template>
    <div class="big-circle-group">
        <template v-for="(option, index) in step.options" :key="index">
            <div v-if="option.disabled?.value != true" class="big-circle" :class="{ 'active': step.selected.value.id === option.id }">
                <div v-if="option.id === step.recommendedOption?.value.id" class="recommendation-label">
                    Recommended for<br/>your measurements
                    <div class="recommendation-triangle"></div>
                </div>
                <BButton class="option__link" @click="emit('select-option', step, option)">
                    <div class="img-wrapper swatch-toggle swatch-toggle--l"><Image :src="option.image" /></div>
                    <span class="option__label">{{ option.label }}</span>
                    <div class="option__underline"></div>
                </BButton>
            </div>
        </template>
    </div>
</template>